(() => {
  const key = 'growhausProductLoginReturn';
  const valid = value => {
    if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\u0000-\u001f]/.test(value)) return null;
    const url = new URL(value, location.origin);
    return url.origin === location.origin && /\/products\/[^/]+/.test(url.pathname)
      ? url.pathname + url.search + url.hash : null;
  };
  const save = value => {
    try { sessionStorage.setItem(key, JSON.stringify({ value, time: Date.now() })); } catch {}
  };
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  if (document.body.dataset.growhausLoggedIn === 'true') {
    clear();
    return;
  }
  if (document.body.dataset.growhausPageType === 'product') {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href]');
      if (!link) return;
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || !/\/account\/login\/?$/.test(url.pathname)) return;
      const target = new URL(location.href);
      const variant = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (variant?.value) target.searchParams.set('variant', variant.value);
      target.searchParams.delete('preview_theme_id');
      const value = valid(target.pathname + target.search + target.hash);
      if (!value) return;
      save(value);
      url.searchParams.set('return_url', value);
      link.href = url.href;
    }, true);
  }
  const form = document.querySelector('#CustomerLoginForm form');
  if (!form) return;
  const params = new URLSearchParams(location.search);
  let value = valid(params.get('return_url') || params.get('return_to'));
  if (!value) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (saved && Date.now() - saved.time < 15 * 60 * 1000) value = valid(saved.value);
      else clear();
    } catch { clear(); }
  }
  if (!value) return;
  save(value);
  let input = form.querySelector('input[name="return_to"]');
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    form.appendChild(input);
  }
  input.value = value;
})();
